import hj from '@hotjar/browser'
import { GuardianService } from '@/services'
import store from '@/store/store'

export class HotJar {
	static async init() {
		const { state } = store

		if (state.user && state.user.id) {
			const userDataResponse = await GuardianService.getUserBrokerAndFranchising(parseInt(state.user.id))
			const [franquia, parceiro] = userDataResponse.result

			hj.init(3855969, 6)

			hj.identify(state.user.id, {
				parceiro_id: state.user.parceiroId,
				franquia_id: state.user.franquiaId,
				franquia: franquia.text,
				parceiro: parceiro.text
			} as any)
		}
	}
}

setTimeout(() => HotJar.init(), 2000)
